var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#9B9B9B",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M20.525 4.4c.65 0 1.175.526 1.175 1.175V7.46h0a2.041 2.041 0 100 4.08v1.885c0 .65-.526 1.175-1.175 1.175H4.475c-.65 0-1.175-.526-1.175-1.175V11.54h0a2.041 2.041 0 100-4.08V5.575c0-.65.526-1.175 1.175-1.175h16.05z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9B9B9B",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.9 7.8h4.6m-4.6 3.4h9.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M1.575 17.433l20.7-15.866"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9B9B9B",
    strokeWidth: 1.02,
    d: "M2.725 17.433l20.7-15.866"
  }))));
}
export default SvgCancelGrey;